

export const columns = [
    { field: 'id', headerName: 'ID', flex: 1, minWidth: 90, columnVisibilityModel: true },
    { field: 'name', headerName: 'Nombre', flex: 1, minWidth: 250 },
    { field: 'category', headerName: 'Catgoría', flex: 1, minWidth: 100 },
    { field: 'zona', headerName: 'Zona', flex: 1, minWidth: 90 },
    { field: 'puntos_favor', headerName: 'Puntos Favor', type: 'number', flex: 1, minWidth: 110 },
    { field: 'puntos_contra', headerName: 'Puntos Contra', type: 'number', flex: 1, minWidth: 130 },
    { field: 'partidos_ganados', headerName: 'Ganados', type: 'number', flex: 1, minWidth: 90 },
    { field: 'partidos_perdidos', headerName: 'Perdidos', type: 'number', flex: 1, minWidth: 90 },
    { field: 'sets_ganados', headerName: 'Sets Ganados', type: 'number', flex: 1, minWidth: 90 },
    { field: 'sets_perdidos', headerName: 'Sets Perdidos', type: 'number', flex: 1, minWidth: 90 },
    { field: 'puntos', headerName: 'Puntos', type: 'number', flex: 1, minWidth: 90 },
    
  ];